import ActionBase, { ACTION_TYPES } from './ActionBase.js';
import Store from '../../Store.js';

/**
 * @module Core/data/stm/action/AddAction
 */
const
    STORE_PROP      = Symbol('STORE_PROP'),
    MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');

/**
 * Action to record the fact of models adding to a store.
 * @extends Core/data/stm/action/ActionBase
 */
export default class AddAction extends ActionBase {
    static $name = 'AddAction';

    static get defaultConfig() {
        return {
            /**
             * Reference to a store models have been added into.
             *
             * @prp {Core.data.Store}
             * @readonly
             * @default
             */
            store : undefined,

            /**
             * List of models added into the store.
             *
             * @prp {Core.data.Model[]}
             * @readonly
             * @default
             */
            modelList : undefined,

            /**
             * Flag showing if undo/redo should be done silently i.e. with events suppressed
             *
             * @prp {Boolean}
             * @readonly
             * @default
             */
            silent : false
        };
    }

    get type() {
        return ACTION_TYPES.ADD;
    }

    //<debug>
    afterConfig() {
        super.afterConfig();

        console.assert(
            this.store instanceof Store &&
            Array.isArray(this.modelList) &&
            this.modelList.length &&
            this.modelList.every(m => m.isModel),
            "Can't create action, bad configuration!"
        );
    }
    //</debug>

    get store() {
        return this[STORE_PROP];
    }

    set store(store) {
        //<debug>
        console.assert(
            !this[STORE_PROP] && store && store instanceof Store,
            "Can't set store, store is required and can be set only once!"
        );
        //</debug>

        this[STORE_PROP] = store;
    }

    get modelList() {
        return this[MODEL_LIST_PROP];
    }

    set modelList(list) {
        //<debug>
        console.assert(
            !this[MODEL_LIST_PROP] &&
            Array.isArray(list) &&
            list.length,
            list.every(m => m.isModel),
            "Can't set model list, model list is required it should be array of Models and it can be set only once!"
        );
        //</debug>

        this[MODEL_LIST_PROP] = list.slice(0);
    }

    undo() {
        this.store.remove(this.modelList, this.silent);
    }

    redo() {
        this.store.add(this.modelList, this.silent);
    }
}
